export const modalTokens = {
  zIndex: 1000,
  backdropOpacity: 0.6,
  transitionDurationMs: 200,
};
